import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { useIcsFormPdfPreview } from 'components/IAP/context/IcsFormPdfPreviewContext';

const ICSFormsExport: React.FC = () => {
  const { exportAsForm } = useIcsFormPdfPreview();

  const handleExportForm = (formname: string) => {
    void exportAsForm({ formname, data: {}, mapSketch: null });
  };

  return (
    <>
      <div className="planning-widget p-3">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="mt-0">
            <SharedIcon iconName="download" classes="me-2" />
            ICS Form Export
          </h3>
        </div>
        <div className="text-weak">
          Export completed ICS forms for the planning meeting
        </div>
        <div className="d-flex justify-content-center gap-2 flex-wrap mt-3">
          <StylishNewButton
            className="button button--secondary mt-2"
            onClick={() => handleExportForm('ICS_215_CG')}
          >
            <SharedIcon iconName="visibility" classes="me-2" />
            Preview ICS-215
          </StylishNewButton>
          <StylishNewButton
            className="button button--secondary mt-2"
            onClick={() => handleExportForm('ICS_215A_CG')}
          >
            <SharedIcon iconName="visibility" classes="me-2" />
            Preview ICS-215A
          </StylishNewButton>
          <StylishNewButton
            className="button button--secondary mt-2"
            onClick={() => handleExportForm('ICS_213RR_CG')}
          >
            <SharedIcon iconName="visibility" classes="me-2" />
            Preview ICS-213RR
          </StylishNewButton>
        </div>
      </div>
    </>
  );
};

export default ICSFormsExport;
